export default __webpack_public_path__ + "static/media/loading.4315d46f.gif";